import {h, render} from 'preact';
import FilterSideBar from "./SearchBar/FilterSideBar";

function SearchBar({facets, query, onChange}) {
    return (
        <div className="mSearchBar">
            <FilterSideBar facets={facets} onChange={onChange}/>

            <div className="mSearchBar__Query__Wrapper">
                <svg className="mSearchBar__SearchIcon" xmlns="http://www.w3.org/2000/svg" width="35.3" height="34.9"
                     viewBox="0 0 35.3 34.9">
                    <path fill="#323232"
                          d="M25.4,23.9c2.2-2.5,3.5-5.8,3.5-9.4c0-8-6.5-14.5-14.5-14.5S0,6.5,0,14.5s6.5,14.5,14.5,14.5c3.8,0,7.3-1.5,9.9-4l9.9,9.9l1.1-1.1L25.4,23.9z M14.5,27.4c-7.1,0-13-5.8-13-13s5.8-13,13-13s13,5.8,13,13S21.6,27.4,14.5,27.4z"></path>
                </svg>
                <input type="search" name="query" value={query} onInput={onChange} className="mSearchBar__Query" placeholder="Rechercher..."/>
            </div>
        </div>)
}

export default SearchBar
